export default __webpack_public_path__ + "static/media/musical-bird.5ded3041.png";